import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Strict Mode disabled: double-invocation of effects breaks WebRTC / MediaStream lifecycle in dev.
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
